<template>
  <div>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-2">
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="model.companyName"
              name="name"
              :label="$t('CompanyName')"
              v-validate="{
                required: 'true',
                min: '2',
                max: '150'
              }"
            />
            <span class="text-danger text-sm" v-show="errors.has('name')">{{
              errors.first("name")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="model.companyRegistrationNumber"
              name="registrationNumber"
              :label="$t('CompanyRegistrationNumber')"
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                min: '2',
                max: '150'
              }"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('registrationNumber')"
              >{{ errors.first("registrationNumber") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="model.companyNationalId"
              name="companyNationalId"
              :label="$t('CompanyNationalId')"
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                min: '2',
                max: '150'
              }"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('companyNationalId')"
              >{{ errors.first("companyNationalId") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="model.economicCode"
              name="economicCode"
              :label="$t('EconomicCode')"
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                min: '2',
                max: '150'
              }"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('economicCode')"
              >{{ errors.first("economicCode") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="model.holdersOfTheRightToSignName"
              name="holdersOfTheRightToSignName"
              v-validate="{
                required: 'true',
                min: '2',
                max: '150'
              }"
              :label="$t('HoldersOfTheRightToSignName')"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('holdersOfTheRightToSignName')"
              >{{ errors.first("holdersOfTheRightToSignName") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="model.agentOwnerName"
              name="owner"
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                min: '10',
                max: '15'
              }"
              :label="$t('AgentOwnerNumber') + ' (نام کاربری)'"
            />
            <span class="text-danger text-sm" v-show="errors.has('owner')">{{
              errors.first("owner")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-for="phone in model.agentPhonesCommand"
              :key="phone.id"
              v-model="phone.area"
              name="area"
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                min: '3',
                max: '6'
              }"
              :label="$t('PhoneArea')"
            />
            <span class="text-danger text-sm" v-show="errors.has('area')">{{
              errors.first("area")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-for="phone in model.agentPhonesCommand"
              :key="phone.id"
              v-model="phone.number"
              name="number"
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                min: '5',
                max: '11'
              }"
              :label="$t('PhoneNumber')"
            />
            <span class="text-danger text-sm" v-show="errors.has('number')">{{
              errors.first("number")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="model.emailAddress"
              name="email"
              v-validate="{
                required: 'true',
                email: 'true',
                max: '150'
              }"
              :label="$t('Email')"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{
              errors.first("email")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full mt-1">
            <label class="vs-select--label">{{ $t("Province") }}</label>
            <v-select
              label="name"
              :options="allProvinces"
              name="province"
              :reduce="x => ({ provinceId: x.id, provinceName: x.name })"
              v-validate="{ required: 'true' }"
              ref="provinceListSelect"
              v-for="address in model.addressesInfoCommand"
              :key="address.id"
              v-model="address.agentProvinceInfo"
              @input="selectProvince"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('province')">{{
              errors.first("province")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full mt-1">
            <label class="vs-select--label mt-4">{{ $t("City") }}</label>
            <v-select
              label="name"
              name="city"
              :options="allCities"
              :reduce="x => ({ cityId: x.id, cityName: x.name })"
              v-for="address in model.addressesInfoCommand"
              :key="address.id"
              v-model="address.agentCityInfo"
              v-validate="{ required: 'true' }"
              :clearable="true"
              ref="cityListSelect"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('city')">{{
              errors.first("city")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-for="address in model.addressesInfoCommand"
              :key="address.id"
              v-model="address.postalCode"
              name="postalCode"
              v-validate="{
                required: 'true',
                regex: '^([0-9]+)$',
                digits: '10'
              }"
              :label="$t('PostalCode')"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('postalCode')"
              >{{ errors.first("postalCode") }}</span
            >
          </div>

          <div class="vx-col w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-for="address in model.addressesInfoCommand"
              :key="address.id"
              v-model="address.address"
              name="address"
              :label="$t('Address')"
              v-validate="{
                required: 'true',
                min: '3',
                max: '500'
              }"
            />
            <span class="text-danger text-sm" v-show="errors.has('address')">{{
              errors.first("address")
            }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2">
            <vs-checkbox
              @click="isHasMember($event)"
              :checked="model.agentBranchInfo"
              class="w-10/12"
              >{{ $t("hasBranch") }}
            </vs-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card mt-3">
      <div class="vx-card__header">
        <div class="vx-card__title">
          <h4>{{ $t("TaxInfo") }}</h4>
        </div>
      </div>
      <div class="vx-card__body card-body">
        <div class="vx-row mb-2">
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <label class="vs-input--label">{{ $t("Title") }}</label>
            <v-select
              label="name"
              name="titleTaxTypes"
              :options="titleTaxTypes"
              v-model="
                model.legalAgentTaxInfo.legalAgentPersonalityCommand.title
              "
              :clearable="false"
              v-validate="{
                required: 'true'
              }"
              :reduce="x => x.id"
              dir="rtl"
            >
            </v-select>

            <span
              class="text-danger text-sm"
              v-show="errors.has('titleTaxTypes')"
              >{{ errors.first("titleTaxTypes") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <label class="vs-select--label">{{ $t("Type") }}</label>
            <v-select
              label="name"
              name="typeTaxTypes"
              :options="typeTaxTypes"
              v-model="
                model.legalAgentTaxInfo.legalAgentPersonalityCommand
                  .personalityType
              "
              :clearable="false"
              v-validate="{
                required: 'true'
              }"
              :reduce="x => x.id"
              dir="rtl"
            >
            </v-select>

            <span
              class="text-danger text-sm"
              v-show="errors.has('typeTaxTypes')"
              >{{ errors.first("typeTaxTypes") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <label class="vs-select--label">{{ $t("Province") }}</label>
            <v-select
              label="name"
              :options="allProvincesOfTadbir"
              name="provinceOfTadbir"
              :reduce="x => x.id"
              v-validate="{ required: 'true' }"
              ref="provinceOfTadbirListSelect"
              v-model="model.legalAgentTaxInfo.provinceId"
              @input="selectProvinceOfTadbir"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('provinceOfTadbir')"
              >{{ errors.first("provinceOfTadbir") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <label class="vs-select--label mt-4">{{ $t("City") }}</label>
            <v-select
              label="name"
              name="cityOfTadbir"
              :options="allCitiesOfTadbir"
              :reduce="x => x.id"
              v-model="model.legalAgentTaxInfo.cityId"
              v-validate="{ required: 'true' }"
              :clearable="true"
              ref="cityOfTadbirListSelect"
              dir="rtl"
            >
            </v-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('cityOfTadbir')"
              >{{ errors.first("cityOfTadbir") }}</span
            >
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button
              type="filled"
              class="float-right submit-btn md:w-auto w-full mt-2"
              @click.prevent="submitForm()"
              :disabled="disabled"
              >{{ $t("Save") }}</vs-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.submit-btn:focus {
  color: #fff !important;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
const dict = {
  custom: {
    name: {
      required: "لطفا نام شرکت را وارد نمایید.",
      regex: "نام شرکت وارد شده معتبر نیست.",
      max: "نام شرکت وارد شده معتبر نیست.",
      min: "نام شرکت وارد شده معتبر نیست."
    },
    registrationNumber: {
      required: "لطفا شماره ثبت را وارد نمایید.",
      regex: "شماره ثبت وارد شده معتبر نیست.",
      max: "شماره ثبت وارد شده معتبر نیست.",
      min: "شماره ثبت نامعتبر می باشد."
    },
    companyNationalId: {
      required: "لطفا شناسه ملی را وارد نمایید.",
      regex: "شناسه ملی وارد شده معتبر نیست.",
      max: "شناسه ملی وارد شده معتبر نیست.",
      min: "شناسه ملی وارد شده معتبر نیست."
    },
    economicCode: {
      required: "لطفا شماره اقتصادی را وارد نمایید.",
      regex: "شماره اقتصادی وارد شده معتبر نیست.",
      max: "شماره اقتصادی وارد شده معتبر نیست.",
      min: "شماره اقتصادی وارد شده معتبر نیست."
    },
    holdersOfTheRightToSignName: {
      required: "لطفا نام صاحبان حق امضا را وارد نمایید.",
      regex: "نام صاحبان حق امضا وارد شده معتبر نیست.",
      max: "نام صاحبان حق امضا وارد شده معتبر نیست.",
      min: "نام صاحبان حق امضا وارد شده معتبر نیست."
    },
    owner: {
      required: "لطفا شماره موبایل مالک اصلی را وارد نمایید.",
      regex: "شماره موبایل مالک اصلی وارد شده معتبر نیست.",
      max: "شماره موبایل مالک اصلی وارد شده معتبر نیست.",
      min: "شماره موبایل مالک اصلی وارد شده معتبر نیست."
    },
    area: {
      required: "لطفا پیش شماره را وارد نمایید.",
      regex: "پیش شماره وارد شده معتبر نیست.",
      max: "پیش شماره وارد شده معتبر نیست.",
      min: "پیش شماره وارد شده معتبر نیست."
    },
    number: {
      required: "لطفا شماره تلفن را وارد نمایید.",
      regex: "شماره تلفن وارد شده معتبر نیست.",
      max: "شماره تلفن وارد شده معتبر نیست.",
      min: "شماره تلفن وارد شده معتبر نیست."
    },
    email: {
      required: "لطفا پست الکترونیک را وارد نمایید.",
      email: "پست الکترونیک وارد شده معتبر نیست.",
      max: "پست الکترونیک وارد شده معتبر نیست."
    },
    province: {
      required: "لطفا استان را انتخاب نمایید."
    },
    city: {
      required: "لطفا شهر را انتخاب نمایید."
    },
    provinceOfTadbir: {
      required: "لطفا استان را در قمست مشخصات مالیاتی انتخاب نمایید."
    },
    cityOfTadbir: {
      required: "لطفا شهر را در قمست مشخصات مالیاتی انتخاب نمایید."
    },
    postalCode: {
      required: "لطفا کدپستی را وارد نمایید.",
      regex: "کدپستی وارد شده معتبر نیست.",
      digits: "کدپستی وارد شده معتبر نیست."
    },
    address: {
      required: "لطفا آدرس را وارد نمایید.",
      max: "شماره تلفن وارد شده معتبر نیست.",
      min: "شماره تلفن وارد شده معتبر نیست."
    },
    titleTaxTypes: {
      required: "لطفا عنوان را در قمست مشخصات مالیاتی انتخاب نمایید."
    },
    typeTaxTypes: {
      required: "لطفا نوع را در قمست مشخصات مالیاتی انتخاب نمایید."
    }
  }
};
Validator.localize("fa", dict);
export default {
  data() {
    return {
      titleTaxTypes: [
        { name: "خصوصی", id: 0 },
        { name: "دولتی", id: 1 },
        { name: "مشارکت مدنی", id: 2 }
      ],
      typeTaxTypes: [
        { name: "وزارت", id: 1 },
        { name: "موسسه دولتی", id: 2 },
        { name: "شرکت دولتی", id: 3 },
        { name: "سایر دستگاه‌های دولتی", id: 4 },
        { name: "نهادهای عمومی غیر‌دولتی", id: 5 },
        { name: "بخش خصوصی", id: 6 },
        { name: "سایر", id: 7 }
      ],
      model: {
        companyRegistrationNumber: null,
        companyNationalId: null,
        companyName: "",
        economicCode: null,
        holdersOfTheRightToSignName: "",
        agentBranchInfo: 0,
        emailAddress: "",
        agentOwnerName: "",
        addressesInfoCommand: [
          {
            agentProvinceInfo: {
              provinceId: null,
              provinceName: ""
            },
            agentCityInfo: {
              cityId: null,
              cityName: ""
            },
            address: "",
            postalCode: ""
          }
        ],
        legalAgentTaxInfo: {
          legalAgentPersonalityCommand: {
            title: null,
            personalityType: null
          },
          provinceId: null,
          cityId: null
        },
        agentPhonesCommand: [
          {
            area: "",
            number: ""
          }
        ]
      },
      disabled: false
    };
  },
  mounted() {
    this.fetchProvinces();
    this.fetchProvincesOfTadbir();
  },
  computed: {
    ...mapGetters({
      allProvinces: "country/provinceList",
      allProvincesOfTadbir: "country/provinceOfTadbirList",
      allCities: "country/cityList",
      allCitiesOfTadbir: "country/cityOfTadbirList"
    })
  },
  methods: {
    ...mapActions({
      createAgent: "legal/createAgent",
      fetchProvinces: "country/fetchProvinces",
      fetchProvincesOfTadbir: "country/fetchProvincesOfTadbir",
      fetchCitiesById: "country/fetchCitiesById",
      fetchCitiesOfTadbirById: "country/fetchCitiesOfTadbirById"
    }),
    selectProvince(province) {
      this.fetchCitiesById(province.provinceId);
      if (this.$refs.cityListSelect) {
        this.$refs.cityListSelect[0].clearSelection();
      }
    },
    selectProvinceOfTadbir(provinceOfTadbir) {
      this.fetchCitiesOfTadbirById(provinceOfTadbir);
      if (this.$refs.cityOfTadbirListSelect) {
        this.$refs.cityOfTadbirListSelect.clearSelection();
      }
    },
    isHasMember(val) {
      if (val.target.checked) this.model.agentBranchInfo = 1;
      else this.model.agentBranchInfo = 0;
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.disabled = true;
          this.createAgent(this.model)
            .then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000
              }).then(() => {
                this.$router.push("/Agents/Index");
              });
              this.$validator.reset();
            })
            .catch(() => {
              this.disabled = false;
            });
        } else {
          // form have errors
        }
      });
    }
  },
  components: {
    "v-select": vSelect
  }
};
</script>
